import React from "react";
import "./LegalContent.styles.css";

const DisclaimerPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="cm-legal-content-container">
      <div className="inner-banner">
        <h2 className="cm-section-h cm-txt-center cm-white-col">Disclaimer</h2>
      </div>
      <div className="cm-section cm-page-center cm-lr-pad pb-10">
        <p>
          This disclaimer outlines the general limitations of liability and
          warranties governing access to and use of this website. By using this
          website, users acknowledge and agree to the terms stated in this
          disclaimer.
        </p>

        <p>
          <a href="https://airefare.net">
            <strong>Airefare</strong>
          </a>{" "}
          makes every reasonable effort to ensure that the information provided
          on this website is accurate and up to date at the time of publication.
          However, no guarantees or representations are made regarding the
          completeness, reliability, or accuracy of such information.
        </p>

        <p>
          Any reliance placed on the information available on this website is
          strictly at the user’s own risk. All intellectual property rights
          related to the content on this website are owned exclusively by{" "}
          <a href="https://airefare.net">
            <strong>Airefare</strong>
          </a>
          . Users are responsible for maintaining the confidentiality and
          security of their login credentials, including User ID and password.
        </p>

        <p>
          <a href="https://airefare.net">
            <strong>Airefare</strong>
          </a>{" "}
          shall not be held responsible for the content, claims, offers, or
          representations of any third-party websites linked to or from this
          website, regardless of whether such links are authorized.
        </p>
      </div>
    </div>
  );
};

export default DisclaimerPage;
